<!-- ADMISSÃO -->
<mat-toolbar class="titulopartes">Admissão</mat-toolbar>
<div fxLayout="row" fxLayoutGap="20px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>

    <div fxFlex="15%" fxFlexOffset="20px">
        <mat-form-field fxFlex="90%">
            <input matInput maxlength="15" name="matricula"
                   placeholder="Matrícula" [disabled]="isEditarMatricula"
                   [(ngModel)]="aluno.matriculaAluno">
        </mat-form-field>

        <div style="padding-top: 14px; display: flex; flex-direction: column; gap: 8px;">
            <button *ngIf="!aluno.matriculaAluno" type="button" mat-icon-button (click)="carregarMatriculaAluno()"
                    matTooltip="Carregar matrícula">
                <mat-icon>autorenew</mat-icon>
            </button>

            <button *ngIf="aluno.matriculaAluno" type="button" mat-icon-button (click)="editarMatricula()" matTooltip="Editar número da matricula">
                <mat-icon>create</mat-icon>
            </button>
        </div>
    </div>

    <mat-form-field fxFlex="80%">
        <mat-label>Selecione a Unidade</mat-label>
        <mat-select name="unidade" [(ngModel)]="aluno.unidade" required>
            <mat-option *ngFor="let u of unidades" [value]="u">
                {{ u.nomeUnidade }}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <mat-checkbox fxFlex="10%" style="padding-top: 24px;" color="primary"
                  name="stAtivo"
                  [(ngModel)]="aluno.stAtivo">Ativo?
    </mat-checkbox>

    <!--
      <mat-checkbox fxFlex="10%"
        style="padding-top: 24px;"
        color="primary"
        name="campoAtivo"
        [(ngModel)]="aluno.stAtivo">
       Ativo?
      </mat-checkbox>
    -->
</div>


<div fxLayout="row" fxLayoutGap="20px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>
    <div ngModelGroup="comboPrograma" fxFlex="50%" fxLayoutGap="20px">
        <mat-toolbar class="titulopartes">Programa</mat-toolbar>
        <combo-programa [showDisplayId]="false"
                        [obrigatorio]="false"
                        [selecionado]="aluno.programa"
                        (valorChange)="onValorChangePrograma($event)">
        </combo-programa>
    </div>

    <div ngModelGroup="comboProjeto" fxFlex="50%" fxLayoutGap="20px">
        <mat-toolbar class="titulopartes">Projeto</mat-toolbar>
        <combo-projeto [showDisplayId]="false"
                       [obrigatorio]="false"
                       [selecionado]="aluno.projeto"
                       (valorChange)="onValorChangeProjeto($event)">
        </combo-projeto>
    </div>

    <div ngModelGroup="comboMatriculaSecretaria" fxFlex="50%" fxLayoutGap="20px">
        <mat-toolbar class="titulopartes">Matrícula secretaria</mat-toolbar>
        <combo-matricula-secretaria [showDisplayId]="false"
                                    [obrigatorio]="false"
                                    [unidade]="aluno.unidade"
                                    [selecionado]="aluno.matriculaSecretaria"
                                    (valorChange)="onValorChangeMatriculaSecretaria($event)">
        </combo-matricula-secretaria>
    </div>

</div>

<mat-toolbar class="titulopartes">CRAS de Referência</mat-toolbar>
<div fxLayout="row" fxLayoutGap="20px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>
    <div ngModelGroup="comboEmpresaSocial" fxFlex>
        <combo-empresa-social [showDisplayId]="false"
                              [obrigatorio]="false"
                              [selecionado]="comboEmpresaSocialSelecionado"
                              [label]="'CRAS - Encaminhamento'"
                              (valorChange)="onValorChangeEmpresaSocial($event)">
        </combo-empresa-social>
    </div>

    <mat-form-field fxFlex="20">
        <input matInput name="descFormaIngressoEntidade" placeholder="CRAS Encaminhamento (Importação)"
               [(ngModel)]="aluno.descFormaIngressoEntidade">
    </mat-form-field>

    <mat-form-field fxFlex="20">
        <input matInput name="dataEncaminhamento" [matDatepicker]="dataEncaminhamento"
               placeholder="Data de Encaminhamento do CRAS"
               (input)="onMascaraDataInput($event)"
               [(ngModel)]="aluno.dataEncaminhamento">
        <mat-datepicker-toggle matSuffix [for]="dataEncaminhamento"></mat-datepicker-toggle>
        <mat-datepicker #dataEncaminhamento></mat-datepicker>
    </mat-form-field>

    <mat-form-field fxFlex="20">
        <input matInput name="dataEntrada" [matDatepicker]="dataEntrada" placeholder="Data de entrada"
               (input)="onMascaraDataInput($event)"
               [(ngModel)]="aluno.dataEntrada" required>
        <mat-datepicker-toggle matSuffix [for]="dataEntrada"></mat-datepicker-toggle>
        <mat-datepicker #dataEntrada></mat-datepicker>
    </mat-form-field>
</div>
<div fxLayout="row" fxLayoutGap="20px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>
    <mat-form-field fxFlex="20" fxFlexOffset="20px">
        <input matInput name="dataSugestaoDesligamento" [matDatepicker]="dataSugestaoDesligamento"
               placeholder="Data sugestão de desligamento"
               (input)="onMascaraDataInput($event)"
               [(ngModel)]="aluno.dataSugestaoDesligamento">
        <mat-datepicker-toggle matSuffix [for]="dataSugestaoDesligamento"></mat-datepicker-toggle>
        <mat-datepicker #dataSugestaoDesligamento></mat-datepicker>
    </mat-form-field>

    <mat-form-field fxFlex="20">
        <input matInput name="dataDesligamento"
               (input)="onMascaraDataInput($event)"
               [matDatepicker]="dataDesligamento"
               placeholder="Data de desligamento"
               (ngModelChange)="onDataDesligamentoChange($event)"
               [(ngModel)]="aluno.dataDesligamento">
        <mat-datepicker-toggle matSuffix [for]="dataDesligamento"></mat-datepicker-toggle>
        <mat-datepicker #dataDesligamento></mat-datepicker>
    </mat-form-field>

    <combo-motivo-desligamento fxFlex
                               [selecionado]="aluno.motivoDesligamento"
                               [obrigatorio]="false"
                               (valorChange)="onMotivoDesligamentoChange($event)">
    </combo-motivo-desligamento>

</div>

<!-- OUTRAS INFORMAÇÕES -->
<mat-toolbar class="titulopartes">Outras informações</mat-toolbar>

<div fxLayout="row" fxLayoutGap="20px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>

    <!--
     <mat-form-field fxFlex="30%" fxFlexOffset="20px">
       <mat-label>Mora com o responsável ?</mat-label>
       <mat-select [(ngModel)]="aluno.moraPais" name="moraPais">
         <mat-option *ngFor="let m of sim_nao" [value]="m.flag">
           {{m.tipo}}
         </mat-option>
       </mat-select>
     </mat-form-field>
   -->

    <mat-checkbox fxFlex="25%" fxFlexOffset="20px" color="primary"
                  name="moraPais"
                  [(ngModel)]="aluno.moraPais">Mora com o responsável?
    </mat-checkbox>

    <!--

    <mat-checkbox fxFlex="25%" fxFlexOffset="20px" color="primary"
      name="moraPais"
      [(ngModel)]="aluno.moraPais">Mora com o responsável?
    </mat-checkbox>
  -->
    <!--

    <div style="margin-top: 25px;">
      <mat-checkbox  fxFlex="30%" fxFlexOffset="20px"
        name="moraPais"
        [(ngModel)]="aluno.moraPais">Mora com o responsável?
      </mat-checkbox>
    </div>
    -->

    <!--
      <mat-form-field fxFlex="30%" fxFlexOffset="20px">
        <mat-label>Pais do beneficiário são casados ?</mat-label>
        <mat-select [(ngModel)]="aluno.paisCasados" name="paisCasados">
          <mat-option *ngFor="let m of sim_nao" [value]="m.flag">
            {{m.tipo}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    -->
    <mat-checkbox fxFlex="25%" fxFlexOffset="20px" color="primary"
                  name="paisCasados"
                  [(ngModel)]="aluno.paisCasados">Pais do beneficiário são casados?
    </mat-checkbox>

    <!--
      <mat-form-field fxFlex="30%" fxFlexOffset="20px">
        <mat-label>Pode participar de apresentações externas e publicidades em geral ?</mat-label>
        <mat-select [(ngModel)]="aluno.participaApresentacaoExterna" name="participaApresentacaoExterna">
          <mat-option *ngFor="let m of sim_nao" [value]="m.flag">
            {{m.tipo}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    -->

    <mat-checkbox fxFlex="50%" fxFlexOffset="20px" color="primary"
                  name="participaApresentacaoExterna"
                  [(ngModel)]="aluno.participaApresentacaoExterna">Pode participar de apresentações externas e publicidades em
        geral?
    </mat-checkbox>

</div>

<div fxLayout="row" fxLayoutGap="80px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>

    <mat-checkbox fxFlex="35" style="padding: 20px;" color="primary"
                  [checked]="aluno.publicoPrioritario === 'sim'"
                  (ngModelChange)="aluno.publicoPrioritario = $event ? 'sim' : 'não'"
                  name="publicoPrioritario">
        Aluno é público prioritário
    </mat-checkbox>

    <!-- <combo-tipo-publico-prioritario fxFlex
                                    [selecionado]="aluno.tiposPublicoPrioritario"
                                    [obrigatorio]="false"
                                    (valorChange)="onTipoPublicoPrioritarioChange($event)">
    </combo-tipo-publico-prioritario> -->

    <combo-tipos-publicos-prioritarios
      [aluno]="aluno" (valorChange)="onTiposPublicosPrioritariosChange($event)">
    </combo-tipos-publicos-prioritarios>

</div>


<div fxLayout="row" fxLayoutGap="20px" style="margin-top: 10px; margin-bottom: 10px" fxFlexFill>
    <mat-form-field fxFlexOffset="20px" fxFlex="50%" appearance="outline">
        <mat-label>Descrição da pessoa que busca o beneficiário {{ aluno.unidade.nomeUnidade }}:</mat-label>
        <textarea matInput #message name="descBuscaEscola" [(ngModel)]="aluno.descBuscaEscola" cdkTextareaAutosize
                  #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="2" maxlength="200"></textarea>
        <mat-hint align="end">{{ message.value.length }} / 200</mat-hint>
    </mat-form-field>

    <mat-form-field fxFlex="50%" appearance="outline">
        <mat-label>Observação:</mat-label>
        <textarea matInput #message name="observacoes" [(ngModel)]="aluno.observacoes" cdkTextareaAutosize
                  #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="2" maxlength="2500"></textarea>
        <mat-hint align="end">{{ message.value.length }} / 2500</mat-hint>
    </mat-form-field>

</div>
